import { useTranslation } from 'react-i18next'
import { MealSlot } from './MealSlot'
import type { MealSlot as MealSlotType } from './types'

interface DayCardProps {
  slot: MealSlotType
  dayName: string
  userRole: 'Planner' | 'Member' | null
  isToday?: boolean
  onSlotTap: () => void
  onEditServing?: () => void
  onRemove?: () => void
  onApprove?: () => void
  onDismiss?: () => void
}

export function DayCard({ slot, dayName, userRole, isToday = false, onSlotTap, onEditServing, onRemove, onApprove, onDismiss }: DayCardProps) {
  const { t } = useTranslation('meal-plan')
  const shortDayName = t(`days.short.${slot.dayOfWeek}`)

  return (
    <div className="flex flex-col gap-2">
      <p className="text-xs font-semibold text-muted uppercase tracking-wide">{shortDayName}</p>
      <MealSlot
        slot={slot}
        dayName={dayName}
        userRole={userRole}
        isToday={isToday}
        onTap={onSlotTap}
        onEditServing={onEditServing}
        onRemove={onRemove}
        onApprove={onApprove}
        onDismiss={onDismiss}
      />
    </div>
  )
}
